/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { SellerNavigationQuery } from '@gql/SellerNavigationQuery'

export type NavigationPage = NN<gen.SellerNavigationFragment['pages']>[0]
type NavHolder = { pages: NavigationPage[] }

export function useNavigation(options?: { on?: (i: NavHolder) => void; open?: (on: boolean) => void }) {
  const navigation2 = useState('useNavigation:2', () => shallowRef<NavHolder>({ pages: [] }))
  const initData = () => ({
    index: -1,
    state: 'rest' as 'show' | 'rest' | 'opening' | 'open-no-content' | 'closing',
    page: undefined as undefined | NavigationPage,
    size: 0,
    imgSizes: undefined as undefined | '156px' | '200px',
  })
  const data = useState('useNavigation', () => shallowRef(initData()))
  const timer = useTimeoutGlobal('useNavigation')

  const sellerId = useSellerId('retail')

  function pageSet(page: NavigationPage | None) {
    const fast = data.value.state === 'show' && !!page
    timer.set(
      () => {
        if (page) {
          const size = helpers.toPositive(page?.cols?.length, 0)
          const imgSizes = size === 5 ? ('156px' as const) : ('200px' as const)
          const hasContent = !!page?.cols?.some((i) => i.title?.text?.value || i.rows?.length || i.image)
          data.value = {
            index: navigation.value.findIndex((i) => i.page === page) ?? -1,
            imgSizes,
            size,
            page,
            state: data.value.state === 'show' ? 'show' : hasContent ? 'opening' : 'rest',
          }
          timer.set(() => {
            if (data.value.state === 'opening') data.value = { ...data.value, state: hasContent ? 'show' : 'open-no-content' }
            options?.open?.(hasContent)
          }, 100)
        } else {
          data.value = { ...data.value, state: 'closing' }
          options?.open?.(false)
          timer.set(() => (data.value = initData()), 100)
        }
      },
      fast ? 10 : 200
    )
  }

  useApolloWrap2<gen.SellerNavigationQuery, gen.SellerNavigationQueryVariables>(SellerNavigationQuery)({
    clientId: 'get',
    vars() {
      const handle = sellerId.value
      return handle ? { handle } : undefined
    },
    ui: (i) => i?.publicSeller?.doc?.navigation,
    on: (i) => {
      navigation2.value = { pages: helpers.arr(i.ui?.pages) }
      nextTick(() => options?.on?.(navigation2.value))
    },
  })

  const { linkSellerLink } = useLinks()
  const navigation = computed(() => {
    return helpers.arr(navigation2.value.pages, (page) => {
      return {
        page,
        to: linkSellerLink(page.title?.link),
        red: page.title?.link?.slug === 'sale',
      }
    })
  })

  function timerClear() {
    timer.clear()
    if (data.value.state === 'opening') data.value = initData()
  }

  return { navigation, pageSet, data, timerClear }
}
